import { Text } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { useTier } from "@src/appV2/redesign/Tiers/api/useTier";
import { useTiersBasketSize } from "@src/appV2/redesign/Tiers/api/useTiersBasketSize";
import { BaseTierCard } from "@src/appV2/redesign/Tiers/Cards/BaseTierCard";
import { LimitedTierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/LimitedTierCardWrapper";
import { TIERS_FULL_PATH } from "@src/appV2/redesign/Tiers/paths";
import pluralize from "pluralize";

export function LimitedTierCard() {
  const useTierResponse = useTier();
  const { enabled: isTiersEnabled, successfullyLoadedTier, isLoading } = useTierResponse;
  const { basketSize, basketSizeWord } = useTiersBasketSize();

  if (!isTiersEnabled || !successfullyLoadedTier || isLoading) {
    return null;
  }

  const {
    tier: {
      attributes: { type: tierType },
    },
  } = useTierResponse;

  if (tierType !== "LIMITED") {
    return null;
  }

  return (
    <LimitedTierCardWrapper>
      <BaseTierCard
        title="Limited Access"
        content={
          <Text variant="body1" textAlign="left">
            You&apos;re limited to last-minute shifts and {basketSizeWord}{" "}
            {pluralize("booking", basketSize)} at a time
          </Text>
        }
        footer={
          <Button
            invert
            variant="contained"
            size="medium"
            endIconType="chevron-right"
            sx={{ width: "fit-content" }}
            href={TIERS_FULL_PATH}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.LIMITED_ACCESS_CARD_LEARN_MORE_CLICKED);
            }}
          >
            Learn More
          </Button>
        }
      />
    </LimitedTierCardWrapper>
  );
}
